/**
 * Route for `advertiser-rbac`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { AdvertiserRbacPage } from "../features/advertiser-rbac/AdvertiserRbacPage";

export const advertiserRbacRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/advertiser-rbac",
	component: AdvertiserRbacPage,
});

export default advertiserRbacRoute;
